module.exports = __webpack_public_path__ + "static/img/solve3.0e32c58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/solve3.png
// module id = 25QZ
// module chunks = 1